// @ts-nocheck
import React, { Component } from "react";
import styles from "../css/Details_Edit_Address.module.css";
import DegreeLookUp from "../../../globalcomponents/DegreeLookUp";
import AddressLookUp from "./../../../globalcomponents/AddressLookUpExUs";
import apiFetch from "./../../../api/apiFetch";
import validateRequestNotes from '../../../helper/validateRequestNotes';
import Icon from '../../../components/Icon/Icon';

class Details_Edit_Address extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Wiggle: false,
            REQUEST_NOTE: null,
            view: 0,
            FIRST: this.props.data.data[0].FIRST_NAME,
            LAST: this.props.data.data[0].LAST_NAME,
            COUNTRY_CODE: this.props.data.data[0].COUNTRY_CODE,
            ADDRESS1: "",
            ADDRESS2: "",
            CITY: "",
            STATE: "",
            ZIPCODE: "",
            PROF_ID: this.props.data.data[0].PROF_ID,
            ISVALID: true,
            errorMessage: "",
        };
    }

    firstCapital(str) {
        if (str !== undefined) {
            return str.toLowerCase().replace(/\w\S*/g, function (txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            });
        }
        return "";
    }

    updateAddress(address) {
        this.setState({
            ADDRESS1: address.entADDRESS1,
            ADDRESS2: address.entADDRESS2,
            CITY: address.entCITY,
            COUNTRY_CODE: address.entCOUNTRY,
            STATE: address.entSTATE,
            ZIPCODE: address.entZIPCODE,
        });
    }

    render() {

        //xus - no ctms
        let state = '';

        //DEGREE ARRAY
        let DegreeOptions = [];
        for (var i = 0; i < Object.keys(DegreeLookUp).length; i++) {
            DegreeOptions.push(
                <option key={i} value={Object.keys(DegreeLookUp)[i]}>
                    {Object.keys(DegreeLookUp)[i]}
                </option>
            );
        }

        //SEC ADDRESS ARRAY
        let sec = [];
        
        for (let i = 1; i < this.props.data.secondaryAddresses.length; i++) {

            state = this.props.data.secondaryAddresses[i].STATE.replace(this.props.data.secondaryAddresses[i].COUNTRY_CODE);

            sec.push(
                <div
                    key={i}
                    className={this.state.checked === i ? [styles.address, styles.active].join(" ") : styles.address}
                    onClick={() => {
                        this.setState({
                            checked: i,
                        });
                    }}
                >
                    <input type="radio" name="secondary" checked={this.state.checked === i ? true : false} className={styles.radio} />

                    {`${this.props.data.secondaryAddresses[i].ADDRESS1}, ${this.props.data.secondaryAddresses[i].ADDRESS2 ?? ""} ${this.props.data.secondaryAddresses[i].CITY} ${this.props.data.secondaryAddresses[i].COUNTRY_CODE} ${this.props.data.secondaryAddresses[i].POSTAL_CODE}`}


                </div>
            );
        }

        //ADDITIONAL ADDRESSES
        let index = this.props.addresses.length;
        let addedAddresses = [];

        for (let i = 0; i < this.props.addresses.length; i++) {
            let st1 = this.props.addresses[i].STATE;
            st1 = st1.replace(this.props.addresses[i].STATE, this.props.addresses[i].COUNTRY_CODE);
            addedAddresses.push(
                <div
                    key={i}
                    className={this.state.checked === i + index ? [styles.address, styles.active].join(" ") : styles.address}
                    onClick={() => {
                        //console.log(i + index);
                        this.setState({
                            checked: i + index,
                        });
                    }}
                >
                    <input type="radio" name="secondary" checked={this.state.checked === i + index ? true : false} className={styles.radio} />
                    {`${this.props.addresses[i].ADDRESS1}, ${this.props.addresses[i].ADDRESS2 ?? ""} ${this.props.addresses[i].CITY}, ${st1} ${this.props.addresses[i].POSTAL_CODE}`}
                </div>
            );
        }

        //CHANGE PRIMARY
        let changePri = (
            <div className={styles.body}>
                <div className={styles.changePri}>
                    <div className={styles.menuTitle}>Which address would you like to change to primary?</div>
                    {addedAddresses}
                    <div className={styles.submenu}>
                        Don't see the one you're looking for?{" "}
                        <div
                            className={styles.link}
                            onClick={() => {
                                this.setState({
                                    view: 5,
                                });
                            }}
                        >
                            Add a new address
                        </div>
                    </div>
                    <div className={styles.buttonRow}>
                        <div
                            id={styles.cancel}
                            onClick={() => {
                                this.setState({ view: 0 });
                            }}
                        >
                            BACK
                        </div>
                        <div
                            className={this.state.Wiggle && this.state.Wiggle !== undefined ? styles.Wiggle : ""}
                            id={styles.submit}
                            onClick={() => {
                                this.setState({
                                    view: 2,
                                });
                            }}
                        >
                            NEXT
                        </div>
                    </div>
                </div>
            </div>
        );

        let oldPri = (
            <div className={styles.body}>
                <div className={styles.changePri}>
                    <div className={styles.menuTitle}>How would you like to assign the previous primary address?</div>
                    <div
                        className={this.state.doWithOldPri === 0 ? [styles.address, styles.active].join(" ") : styles.address}
                        onClick={() => {
                            this.setState({
                                doWithOldPri: 0,
                            });
                        }}
                    >
                        <input type="radio" name="secondary" checked={this.state.doWithOldPri === 0 ? true : false} className={styles.radio} />
                        Secondary
                    </div>
                    <div
                        className={this.state.doWithOldPri === 1 ? [styles.address, styles.active].join(" ") : styles.address}
                        onClick={() => {
                            this.setState({
                                doWithOldPri: 1,
                            });
                        }}
                    >
                        <input type="radio" name="secondary" checked={this.state.doWithOldPri === 1 ? true : false} className={styles.radio} />
                        Inactive
                    </div>
                    <div className={styles.buttonRow}>
                        <div
                            id={styles.cancel}
                            onClick={() => {
                                this.setState({ view: 1 });
                            }}
                        >
                            BACK
                        </div>
                        <div
                            className={this.state.Wiggle && this.state.Wiggle !== undefined ? styles.Wiggle : ""}
                            id={styles.submit}
                            onClick={() => {

                                let priRequest = {};
                                console.log('PORTAL: newPriFlag = ' + this.state.newPriFlag);
                                console.log('PORTAL: doWithOldPri = ' + this.state.doWithOldPri);
                                
                                //console.log(index);
                                //console.log(this.state.checked);
                                if (this.state.newPriFlag) {
                                    priRequest = {
                                        ADDRESS1: this.state.newPri.ADDRESS1,
                                        ADDRESS2: this.state.newPri.ADDRESS2,
                                        CITY: this.state.newPri.CITY,
                                        STATE: this.state.newPri.STATE,
                                        COUNTRY: this.state.newPri.COUNTRY_CODE,
                                        ZIPCODE: this.state.newPri.ZIPCODE,
                                        REQUEST_TYPE: `EXUS Set Primary Address`,
                                        PROF_ID: this.props.data.PROF_ID,
                                        REQUESTOR_ID: this.props.user.email,
                                        REQUESTOR_NAME: this.props.user.userName,
                                        REQUESTOR_TEAM: this.props.user.team,
                                        REQUESTOR_TERR: this.props.user.terr,
                                    };
                                } else {

                                    console.log('PORTAL: this.state.checked = ' + this.state.checked);

                                    if (this.state.checked < index) {
                                        priRequest = {
                                            ADDRESS1: this.props.data.secondaryAddresses[this.state.checked].ADDRESS1,
                                            ADDRESS2: this.props.data.secondaryAddresses[this.state.checked].ADDRESS2,
                                            CITY: this.props.data.secondaryAddresses[this.state.checked].CITY,
                                            STATE: this.props.data.secondaryAddresses[this.state.checked].STATE,
                                            COUNTRY: this.props.data.secondaryAddresses[this.state.checked].COUNTRY_CODE,
                                            ZIPCODE: this.props.data.secondaryAddresses[this.state.checked].ZIP5,
                                            REQUEST_TYPE:  `EXUS Set Primary Address`,
                                            PROF_ID: this.props.data.PROF_ID,
                                            REQUESTOR_ID: this.props.user.email,
                                            REQUESTOR_NAME: this.props.user.userName,
                                            REQUESTOR_TEAM: this.props.user.team,
                                            REQUESTOR_TERR: this.props.user.terr,
                                        };



                                      //  console.log('PORTAL: priRequest11 = ' + priRequest.ADDRESS1);


                                    } else {

                                       console.log('PORTAL: ADDITIONAL ADDRESS LIST');

                                        priRequest = {
                                            ADDRESS1: this.props.addresses[this.state.checked - index].ADDRESS1,
                                            ADDRESS2: this.props.addresses[this.state.checked - index].ADDRESS2,
                                            CITY: this.props.addresses[this.state.checked - index].CITY,
                                            STATE: this.props.addresses[this.state.checked - index].STATE,
                                            COUNTRY: this.props.addresses[this.state.checked - index].COUNTRY_CODE,
                                            ZIPCODE: this.props.addresses[this.state.checked - index].POSTAL_CODE,
                                            REQUEST_TYPE:  `EXUS Set Primary Address`,
                                            PROF_ID: this.props.data.data[0].PROF_ID,
                                            REQUESTOR_ID: this.props.user.email,
                                            REQUESTOR_NAME: this.props.user.userName,
                                            REQUESTOR_TEAM: this.props.user.team,
                                            REQUESTOR_TERR: this.props.user.terr,
                                        };


                                       // console.log('PORTAL: priRequest22 = ' + priRequest.ADDRESS1);
                                    }
                                }

                               // console.log('ok with pri request');

                                if (this.state.doWithOldPri === 0) {
                                    let batch = {
                                        PROF_ID: this.state.PROF_ID,
                                        REQUESTOR_ID: this.props.user.email,
                                        REQUESTOR_NAME: this.props.user.userName,
                                        REQUESTOR_TEAM: this.props.user.team,
                                        REQUESTOR_TERR: this.props.user.terr,
                                        REQUEST_TYPE: "EXUS HCP Update Address"
                                    };

                                    let secRequest = {
                                        ADDRESS1: this.props.addresses[0].ADDRESS1,
                                        ADDRESS2: this.props.addresses[0].ADDRESS2,
                                        CITY: this.props.addresses[0].CITY,
                                        STATE: this.props.addresses[0].STATE,
                                        COUNTRY: this.props.addresses[0].COUNTRY_CODE,
                                        ZIPCODE: this.props.addresses[0].POSTAL_CODE,
                                        PROF_ID: this.state.PROF_ID,
                                        REQUESTOR_ID: this.props.user.email,
                                        REQUESTOR_NAME: this.props.user.userName,
                                        REQUESTOR_TEAM: this.props.user.team,
                                        REQUESTOR_TERR: this.props.user.terr,
                                        REQUEST_TYPE: "EXUS Set Secondary Address",
                                    };
                                    //console.log([priRequest, secRequest]);
                                    apiFetch("/api/v2/global/change-request", batch).then((parent) => {
                                        //   priRequest.ACTION_NUM = parent[0][parent.length - 1].ACTION_ID;
                                        //   secRequest.ACTION_NUM = parent[0][parent.length - 1].ACTION_ID;

                                        //  priRequest.ACTION_NUM = parent.ACTION_ID;
                                        //  secRequest.ACTION_NUM = parent.ACTION_ID;

                                        this.props.submit([priRequest, secRequest], true);
                                    });

                                } else {
                                    this.props.submit(priRequest);
                                }
                            }}
                        >
                            SUBMIT
                        </div>
                    </div>
                </div>
            </div>
        );

        let remove = [];
        for (let i = 0; i < this.props.addresses.length; i++) {
            remove.push(
                <div
                    key={i}
                    className={this.state.checked === i ? [styles.address, styles.active].join(" ") : styles.address}
                    onClick={() => {
                        this.setState({
                            checked: i,
                        });
                    }}
                >
                    <input type="radio" name="secondary" checked={this.state.checked === i ? true : false} className={styles.radio} />
                    {`${this.props.addresses[i].ADDRESS1}, ${this.props.addresses[i].CITY}, ${this.props.addresses[i].COUNTRY_CODE} ${this.props.addresses[i].POSTAL_CODE}`}
                </div>
            );
        }

        let removeAddress = (
            <div className={styles.body}>
                <div className={styles.changePri}>
                    <div className={styles.menuTitle}>Which address would you like to remove?</div>
                    <div className={styles.required} style={{ margin: "10px" }}>
                        {this.state.checked === null ? "Error: You cannot remove a primary address. If the HCP has moved, submit an address change or move to unknown." : ""}
                    </div>
                    {remove}
                    <div className={styles.buttonRow}>
                        <div
                            id={styles.cancel}
                            onClick={() => {
                                this.setState({ view: 0 });
                            }}
                        >
                            BACK
                        </div>
                        <div
                            className={this.state.Wiggle && this.state.Wiggle !== undefined ? styles.Wiggle : ""}
                            id={styles.submit}
                            onClick={() => {
                                if (this.state.checked !== null && this.props.addresses.length > 0) {
                                    let temp = {
                                        ADDRESS1: this.props.addresses[this.state.checked].ADDRESS1,
                                        ADDRESS2: this.props.addresses[this.state.checked].ADDRESS2,
                                        CITY: this.props.addresses[this.state.checked].CITY,
                                        STATE: this.props.addresses[this.state.checked].STATE,
                                        ZIPCODE: this.props.addresses[this.state.checked].POSTAL_CODE,
                                        REQUEST_TYPE: "EXUS Deactivate Address",
                                    };
                                    this.props.submit(temp);
                                } else {
                                    this.setState({
                                        Wiggle: true,
                                        ISVALID: false,
                                    });
                                    setTimeout(() => {
                                        this.setState({ Wiggle: false });
                                    }, 500);
                                }
                            }}
                        >
                            SUBMIT
                        </div>
                    </div>
                </div>
            </div>
        );

        let addSecondary = (

            <div className={styles.body}>
                <div className={styles.changePri}>
                    <div className={styles.menuTitle}>Which address would you like to add as secondary?</div>
                    {sec}
                    <div className={styles.submenu}>
                        Don't see the one you're looking for?{" "}
                        <div
                            className={styles.link}
                            onClick={() => {
                                this.setState({
                                    view: 7,
                                });
                            }}
                        >
                            Add a new address
                        </div>
                    </div>
                    <div className={styles.buttonRow}>
                        <div
                            id={styles.cancel}
                            onClick={() => {
                                this.setState({ view: 0 });
                            }}
                        >
                            BACK
                        </div>
                        <div
                            className={this.state.Wiggle && this.state.Wiggle !== undefined ? styles.Wiggle : ""}
                            id={styles.submit}
                            onClick={() => {
                                let temp = {
                                    ADDRESS1: this.props.data.secondaryAddresses[this.state.checked].ADDRESS1,
                                    ADDRESS2: this.props.data.secondaryAddresses[this.state.checked].ADDRESS2,
                                    CITY: this.props.data.secondaryAddresses[this.state.checked].CITY,
                                    STATE: this.props.data.secondaryAddresses[this.state.checked].STATE,
                                    ZIPCODE: this.props.data.secondaryAddresses[this.state.checked].POSTAL_CODE,
                                    REQUEST_TYPE: "EXUS Add Secondary Address",
                                };
                                this.props.submit(temp);
                                this.setState({
                                    view: 10,
                                });
                            }}
                        >
                            NEXT
                        </div>
                    </div>
                </div>
            </div>
        );
        let newSecondary = (
            <div className={styles.body}>

                <AddressLookUp updateAddress={this.updateAddress.bind(this)} error={this.state.ISVALID} info={this.state} />

                <div className={styles.buttonRow}>
                    <div
                        id={styles.cancel}
                        onClick={() => {
                            this.setState({ view: 3 });
                        }}
                    >
                        BACK
                    </div>
                    <div
                        className={this.state.Wiggle && this.state.Wiggle !== undefined ? styles.Wiggle : ""}
                        id={styles.submit}
                        onClick={() => {
                            if (this.state.ADDRESS1 !== "" && this.state.CITY !== "" && this.state.STATE !== "" && this.state.ZIPCODE.length > 4) {
                                let temp = {
                                    ADDRESS1: this.state.ADDRESS1,
                                    ADDRESS2: this.state.ADDRESS2,
                                    CITY: this.state.CITY,
                                    STATE: this.state.STATE,
                                    ZIPCODE: this.state.ZIPCODE,
                                    REQUEST_TYPE: `EXUS Add Secondary Address`,
                                };
                                this.props.submit(temp);
                                this.setState({
                                    view: 10,
                                });
                            } else {
                                this.setState({
                                    Wiggle: true,
                                    ISVALID: false,
                                });
                                setTimeout(() => {
                                    this.setState({ Wiggle: false });
                                }, 500);
                            }
                        }}
                    >
                        SUBMIT
                    </div>
                </div>
            </div>
        );
        let newPrimary = (
            <div className={styles.body}>

                <AddressLookUp updateAddress={this.updateAddress.bind(this)} error={this.state.ISVALID} info={this.state} />

                <div className={styles.buttonRow}>
                    <div
                        id={styles.cancel}
                        onClick={() => {
                            this.setState({ view: 0 });
                        }}
                    >
                        BACK
                    </div>
                    <div
                        className={this.state.Wiggle && this.state.Wiggle !== undefined ? styles.Wiggle : ""}
                        id={styles.submit}
                        onClick={() => {
                            if (this.state.ADDRESS1 !== "" && this.state.CITY !== "" && this.state.STATE !== "" && this.state.ZIPCODE.length > 4) {
                                let temp = {
                                    ADDRESS1: this.state.ADDRESS1,
                                    ADDRESS2: this.state.ADDRESS2,
                                    CITY: this.state.CITY,
                                    STATE: this.state.STATE,
                                    ZIPCODE: this.state.ZIPCODE,
                                    REQUEST_TYPE: 'EXUS New Primary Address'

                                };
                                this.props.submit(temp);
                                this.setState({
                                    newPri: temp,
                                    newPriFlag: true,
                                    view: 2,
                                });
                            } else {
                                this.setState({
                                    Wiggle: true,
                                    ISVALID: false,
                                });
                                setTimeout(() => {
                                    this.setState({ Wiggle: false });
                                }, 500);
                            }
                        }}
                    >
                        SUBMIT
                    </div>
                </div>
            </div>
        );

        let success = (
            <div className={styles.body}>
                <div className={styles.toprow}>
                    <div className={[styles.set, styles.mainTitle].join(" ")}>
                        <div className={styles.titleText}>
                            <Icon name="check-circle" />
                        </div>
                    </div>
                </div>

                <div className={styles.middlerow}>
                    <div className={styles.set}>
                        <div className={styles.contentTitle}>Thank you!</div>
                        <div className={styles.content}>Your request has been submitted.</div>
                    </div>
                </div>

                <div className={styles.buttonRow}>
                    <div
                        id={styles.cancel}
                        onClick={() => {
                            this.props.close();
                        }}
                    >
                        CLOSE
                    </div>
                </div>
            </div>
        );

        let unkown = (
            <div className={styles.body}>
                <div className={styles.menuTitle}>Move a Professional to unknown</div>
                <div className={styles.set}>
                    <div className={styles.inputTitle}>REVISION REASON</div>
                    <input
                        value={this.state.REQUEST_NOTE ? this.state.REQUEST_NOTE : ""}
                        onChange={(event) => {
                            this.setState({ REQUEST_NOTE: validateRequestNotes(event.target.value) });
                        }}
                    />
                </div>
                <div className={styles.buttonRow}>
                    <div
                        id={styles.submit}
                        onClick={() => {
                            this.props.close();
                        }}
                    >
                        CANCEL
                    </div>
                    <div
                        id={styles.submit}
                        onClick={() => {
                            if (this.state.REQUEST_NOTE !== undefined ? this.state.REQUEST_NOTE : "") {
                                let temp = {
                                    REQUEST_NOTE: this.state.REQUEST_NOTE,
                                    REQUEST_TYPE: `EXUS HCP move to unknown`,
                                };
                                this.props.submit(temp);
                            }
                        }}
                    >
                        CONTINUE
                    </div>
                </div>
            </div>
        );

        let menu = (
            <div className={styles.body}>
                <div className={styles.menuTitle}>What would you like to do?</div>
                <div className={styles.errorMessage}>{this.state.errorMessage}</div>
                <div className={styles.menuButton}>
                    <div
                        id={styles.submit}
                        onClick={() => {
                            this.setState({ view: 1 });
                        }}
                    >
                        CHANGE PRIMARY
                    </div>
                    <div
                        id={styles.submit}
                        onClick={() => {
                            this.setState({ view: 3 });
                        }}
                    >
                        ADD SECONDARY
                    </div>
                    <div
                        id={styles.submit}
                        onClick={() => {
                            if (this.props.addresses.length > 0) {
                                this.setState({ view: 4 });
                            } else {
                                this.setState({
                                    errorMessage: "You can not deactivate this address as it is the only primary address.",
                                });
                            }
                        }}
                    >
                        DEACTIVATE ADDRESS
                    </div>
                    <div
                        id={styles.submit}
                        onClick={() => {
                            this.setState({ view: 6 });
                        }}
                    >
                        MOVE TO UNKNOWN
                    </div>
                </div>
            </div>
        );

        let view = "";
        if (this.state.view === 0) {
            view = menu;
        }
        if (this.state.view === 1) {
            view = changePri;
        }
        if (this.state.view === 2) {
            view = oldPri;
        }
        if (this.state.view === 3) {
            view = addSecondary;
        }
        if (this.state.view === 4) {
            view = removeAddress;
        }
        if (this.state.view === 5) {
            view = newPrimary;
        }
        if (this.state.view === 6) {
            view = unkown;
        }
        if (this.state.view === 7) {
            view = newSecondary;
        }
        if (this.state.view === 10) {
            view = success;
        }

        return (
            <div className={styles.editScreen}>
                <div className={styles.wrapper}>
                    <div className={styles.title}>
                        <div></div>
                        <div className={styles.TitleText}>Edit Address</div>
                        <div
                            className={styles.close}
                            onClick={() => {
                                this.props.close();
                            }}
                        >
                            <span aria-hidden="true">×</span>
                        </div>
                    </div>
                    {view}
                </div>
            </div>
        );
    }
}

export default Details_Edit_Address;
